'use client'

import {
  Pie,
  PieChart as RechartsPieChart,
  ResponsiveContainer,
} from 'recharts'
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
  type ChartData,
} from './chart'

export type ChartPieConfig = {
  stroke: string
  fill: string
  fillOpacity: number
}

function ChartPie({
  config,
  data,
  className,
  showLegend = true,
  showTooltip = true,
}: {
  config: ChartConfig
  data: ChartData[]
  className?: string
  showLegend?: boolean
  showTooltip?: boolean
}) {
  return (
    <ChartContainer config={config} className={className}>
      <ResponsiveContainer>
        <RechartsPieChart>
          <Pie data={data} dataKey='value' nameKey='name' paddingAngle={2} />
          {showTooltip && (
            <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
          )}
          {showLegend && <ChartLegend content={<ChartLegendContent />} />}
        </RechartsPieChart>
      </ResponsiveContainer>
    </ChartContainer>
  )
}

export { ChartPie }
